import { Link } from 'react-router-dom';
import { Config } from '@otp/icons';
import { Card, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import type { User } from 'src/graphql/generated/graphql';
import { Routes } from 'src/components/common/router/constants';

type UserEditActionProps = {
  user: Partial<User>;
};

export const UserEditAction = ({ user }: UserEditActionProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'manage-otps.actions',
  });

  return (
    <Link to={`${Routes.editUserProfile.path.replace(':id', user.id)}`}>
      <Card className="hover:bg-[var(--mui-palette-primary-200)] cursor-pointer">
        <div className="grid grid-cols-12 items-center">
          <Typography variant="subtitle2" className="col-span-11">
            {t('edit-profile')}
          </Typography>
          <Config />
        </div>
      </Card>
    </Link>
  );
};
